//Auth Services
export const AUTH = {
  BASE: '/auth',
  GUEST: '/guest',
  CONVER_GUEST_USER: '/convert-guest-user',
  CONVERT_LOCAL_GUEST_USER: '/convert-local-guest-user',
  LOCAL: '/local',
  REGISTER: '/register',
  CHANGE_PASSWORD: '/change-password'
}

//Users Services
export const USERS = {
  BASE: '/users',
  AVATAR: '/avatar',
  GENDER: '/verify-gender',
  REQUEST_MONETIZATION: '/request-monetization',
  UPLOAD_DOCUMENT: '/upload-document',
  CONFIRM_DOCUMENTS_SUBMIT: '/confirm-documents-submit',
  DELETE_DOCUMENT: '/delete-document'
}

//Realtime Services
export const REALTIME = {
  BASE: '/realtime',
  FRIEND: '/friends',
  MONITOR: '/monitor-call'
}

//History Services
export const HISTORY = {
  BASE: '/histories',
}

//Message Services
export const MESSAGE = {
  BASE: '/messages',
  CONVERSATION: '/conversation',
  RECEIVED: '/received',
  READ: '/read',
  UPLOAD: '/upload'
}

//Friend Services
export const FRIEND = {
  BASE: '/friends',
  REQUEST: '/request',
  ACCEPT: '/accept',
  DECLINE: '/decline',
  FAVORITE: '/favorite',
  UNFRIEND: '/unfriend',
  INFO: '/info'
}

//Friend Services
export const NOTIFICATION = {
  BASE: '/notifications',
  TOKEN: '/token'
}

//User Settings Services
export const USER_SETTINGS = {
  BASE: '/user-settings',
  REPORT: '/report',
  NOTIFICATION: '/notification',
  CONTENT: '/content'
}

//User Settings Services
export const APP_CONFIG = {
  BASE: '/app-config',
  TURN_SERVER: '/turn-server'
}

//User Settings Services
export const TRANSACTIONS = {
  BASE: '/transactions',
}


//User Settings Services
export const PAYMENT = {
  BASE: '/payment',
  PACKAGES: '/packages',
  INTENTS: '/intents'
}